import { useTranslation } from 'react-i18next'
import { Input, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import BrandButton from '@/components/BrandButton'
import type { WorkbenchAppFilter } from './types'

interface AppListToolbarProps {
  search: string
  filter: WorkbenchAppFilter
  onSearchChange: (value: string) => void
  onFilterChange: (value: WorkbenchAppFilter) => void
  onCreate: () => void
}

function AppListToolbar({
  search,
  filter,
  onSearchChange,
  onFilterChange,
  onCreate,
}: AppListToolbarProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <BrandButton onClick={onCreate}>{t('workbench.createApp')}</BrandButton>
      <div className="flex flex-wrap items-center gap-2.5">
        <Input
          allowClear
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('workbench.searchPlaceholder')}
          suffix={<SearchOutlined className="text-black/25" />}
          className="!h-8 !w-[300px] !rounded-lg !border-[#DCDCDC] !bg-white/85"
        />
        <Select
          value={filter}
          onChange={onFilterChange}
          popupMatchSelectWidth={false}
          className="!h-8 !min-w-[120px]"
          options={[
            { value: 'all', label: t('workbench.filterAll') },
            { value: 'pending', label: t('workbench.filterPending') },
            { value: 'published', label: t('workbench.filterPublished') },
          ]}
        />
      </div>
    </div>
  )
}

export default AppListToolbar
